export const fncSetStockData = (state, payload) => {
  state.stockData = payload;
}

export const fncSetPricingTables = (state, payload) => {
  state.pricingTables = payload;
}

export const fncSetSavedStock = (state, payload) => {
  state.savedStock = payload;
}

export const fncSetStockLoaded = (state, payload) => {
  state.stockLoaded = payload;
}
